export class MailDestinatairePInput {
  public type: string; // DESTINATAIRE Or SERVICE
  public destinataireId: number;

  constructor(data?: MailDestinatairePInput) {
    Object.assign(this, data);
  }
}
